/* Diamond Domain - Drop a hint / Get help (Sep 2026, rebuilt twice).

   History, so this does not regress again:
     1. First version had no recipient field and opened a mailto with an empty To.
        On a desktop with no mail app configured, the button did nothing at all.
     2. Second version added the field but still only handed off to the mail app,
        so testing it on a desktop still produced no email. That is what "I put
        email etc but never got email" was.
     3. This version posts Shopify's own contact form, so an email genuinely
        leaves the site. Handing off to the mail app is now the secondary route.

   There is not a single backslash in this file. Newlines are String.fromCharCode(10),
   because escapes do not survive the way this file is written into the theme -
   an earlier version joined on a literal backslash-n and every message came out
   as one run-on line.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var NL = String.fromCharCode(10);
  var root = null;

  function esc(s) { return (s || '').toString().trim(); }
  function val(sel) {
    var el = root.querySelector(sel);
    return el ? esc(el.value) : '';
  }

  function buildMessage() {
    var them = val('[data-dd-them]');
    var me = val('[data-dd-me]');
    var title = root.getAttribute('data-dd-title') || '';
    var price = root.getAttribute('data-dd-price') || '';
    var url = root.getAttribute('data-dd-url') || '';

    var lines = [];
    lines.push(them ? 'Hi ' + them + ',' : 'Hi,');
    lines.push('');
    lines.push('I found this and I have not stopped thinking about it.');
    lines.push('');
    lines.push(title);
    if (price) lines.push(price);
    lines.push(url);
    if (me) { lines.push(''); lines.push('- ' + me); }

    return lines.join(NL);
  }

  function subject() {
    var me = val('[data-dd-me]');
    return me ? 'A ring I love, from ' + me : 'A ring I love';
  }

  function openModal(name) {
    var m = root.querySelector('[data-dd-modal="' + name + '"]');
    if (!m) return;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = m.querySelector('input, a, button');
    if (f) { try { f.focus(); } catch (e) {} }
  }

  function closeModals() {
    root.querySelectorAll('[data-dd-modal]').forEach(function (m) { m.hidden = true; });
    document.documentElement.style.overflow = '';
    var fb = root.querySelector('[data-dd-fallback]');
    if (fb) fb.hidden = true;
  }

  function note(text) {
    var n = root.querySelector('[data-dd-note]');
    if (!n) return;
    var original = n.getAttribute('data-original') || n.textContent;
    n.setAttribute('data-original', original);
    n.textContent = text;
    setTimeout(function () { n.textContent = original; }, 3200);
  }

  function showFallback() {
    var fb = root.querySelector('[data-dd-fallback]');
    var box = root.querySelector('[data-dd-message]');
    if (!fb || !box) return;
    box.value = buildMessage();
    fb.hidden = false;
  }

  /* If the browser has no mail or sms handler the click silently does nothing, so
     reveal the message ready to copy rather than leaving a dead button. Best effort:
     some browsers blur briefly even when nothing opens. */
  function armFallback() {
    var left = false;
    function onLeave() { left = true; }
    document.addEventListener('visibilitychange', onLeave, {once: true});
    window.addEventListener('blur', onLeave, {once: true});
    setTimeout(function () {
      document.removeEventListener('visibilitychange', onLeave);
      window.removeEventListener('blur', onLeave);
      if (!left && !document.hidden) showFallback();
    }, 1500);
  }

  function copy(text, ok) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(function () { note(ok); })
        .catch(function () { showFallback(); });
    } else {
      showFallback();
    }
  }

  function wire() {
    /* The buttons are moved OUT of #dd-hint-root and into the product form, so they must be
       queried from the document. Querying them from root found nothing and silently bound no
       handlers - which is exactly how this failed the first time. */
    document.querySelectorAll('[data-dd-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn.getAttribute('data-dd-open')); });
    });

    root.querySelectorAll('[data-dd-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModals);
    });

    root.querySelectorAll('[data-dd-modal]').forEach(function (m) {
      m.addEventListener('click', function (e) { if (e.target === m) closeModals(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModals();
    });

    /* The real send. Shopify's contact form needs contact[email] and contact[message];
       everything else we name becomes a labelled line in the email that reaches us. */
    var form = root.querySelector('#dd-hint-form') || root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var hidden = root.querySelector('[data-dd-hiddenmessage]');
        if (hidden) hidden.value = buildMessage();
      });
    }

    root.querySelectorAll('[data-dd-send]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var mode = el.getAttribute('data-dd-send');
        var body = buildMessage();

        if (mode === 'email') {
          var to = val('[data-dd-toemail]');
          el.setAttribute(
            'href',
            'mailto:' + to +
            '?subject=' + encodeURIComponent(subject()) +
            '&body=' + encodeURIComponent(body)
          );
          armFallback();
          return;
        }

        e.preventDefault();

        if (mode === 'message') {
          copy(body, 'Message copied. Paste it anywhere.');
          return;
        }

        var url = root.getAttribute('data-dd-url') || '';
        if (navigator.share) {
          navigator.share({ title: root.getAttribute('data-dd-title') || '', url: url }).catch(function () {});
          return;
        }
        copy(url, 'Link copied.');
      });
    });

    var copyBox = root.querySelector('[data-dd-copybox]');
    if (copyBox) {
      copyBox.addEventListener('click', function () {
        var box = root.querySelector('[data-dd-message]');
        if (!box) return;
        try { box.select(); } catch (e) {}
        copy(box.value, 'Message copied. Paste it anywhere.');
      });
    }

    /* Shopify bounces back to this page with contact_posted=true on success. */
    if (window.location.search.indexOf('contact_posted=true') > -1) {
      var sent = root.querySelector('[data-dd-sent]');
      var wrap = root.querySelector('[data-dd-formwrap]');
      if (sent && wrap) {
        sent.hidden = false;
        wrap.hidden = true;
        openModal('hint');
      }
    }
  }

  function place() {
    root = document.getElementById('dd-hint-root');
    if (!root) return true;
    if (root.dataset.ddPlaced === '1') return true;

    var atc = document.querySelector('[data-add-to-cart], button[name="add"]');
    var anchor = atc ? atc.closest('.product__submit__holder') : null;
    if (!anchor) anchor = atc ? atc.closest('.product__block') : null;
    if (!anchor) return false;

    var actions = root.querySelector('.dd-actions');
    anchor.parentNode.insertBefore(actions, anchor.nextSibling);

    var dupe = document.querySelector('.dd-trust__help');
    if (dupe) dupe.style.display = 'none';

    root.hidden = false;
    root.dataset.ddPlaced = '1';
    wire();
    return true;
  }

  function start() {
    if (place()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (place() || ++tries > 20) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();